// Consent Mode v2 bootstrap — MUST execute before the GTM script below.
// Default: granted everywhere, denied only in EEA/UK regions (ISO 3166 codes)
// so the Indonesia-primary audience keeps full measurement while EEA/UK
// visitors are cookieless until they accept via the consent banner.
const EEA_UK_REGIONS = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR',
  'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK',
  'SI', 'ES', 'SE', 'IS', 'LI', 'NO', 'GB', 'CH',
]
export const CONSENT_BOOTSTRAP_SCRIPT = `window.dataLayer=window.dataLayer||[];
function gtag(){dataLayer.push(arguments);}window.gtag=gtag;
gtag('consent','default',{ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied',analytics_storage:'denied',wait_for_update:500,region:${JSON.stringify(EEA_UK_REGIONS)}});
gtag('consent','default',{ad_storage:'granted',ad_user_data:'granted',ad_personalization:'granted',analytics_storage:'granted'});
try{var choice=localStorage.getItem('dropify_consent_v1');if(choice==='granted'||choice==='denied'){gtag('consent','update',{ad_storage:choice,ad_user_data:choice,ad_personalization:choice,analytics_storage:choice});}}catch(e){}`
